import type { FaireProductEntity } from "../../entity_types/product";

export const p_ns3d6ug3xs: FaireProductEntity = {
  token: "p_ns3d6ug3xs",
  type: "product",
  name: "Ritter Sport Dark Marzipan (Germany)",
  brandToken: "b_s2gzfhxg44",
  brandName: "Global Bite Co",
  imageUrl:
    "https://cdn.faire.com/fastly/16721fdc644b863400c597e366276e8fc05cac7abc7d9563a8b36b2703dcdf87.jpeg",
  galleryImageUrls: [],
  priceDollars: 4.16,
  description:
    "Ritter Sport Dark Marzipan is a premium chocolate bar featuring rich dark chocolate filled with smooth almond-based marzipan. Each square blends bittersweet dark chocolate with sweet marzipan, creating a harmonious and indulgent treat. Perfect for chocolate and marzipan enthusiasts, this bar offers a sophisticated and delicious snack or dessert option. Treat yourself to Ritter Sport Dark Marzipan and discover pure chocolate bliss with every bite.\n",
  tags: [],
  msrpDollars: 8.59,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:50:03.865Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
